import * as React from "react";

const WhiteMode = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="svg1"
    width="24"
    height="24"
    version="1.1"
    viewBox="0 0 6.35 6.35"
  >
    <g
      id="layer14"
      fillOpacity="1"
      strokeDasharray="none"
      strokeDashoffset="22.224"
      strokeLinecap="round"
      strokeLinejoin="miter"
      strokeOpacity="1"
    >
      <circle
        id="path68"
        cx="3.175"
        cy="3.175"
        r="2.646"
        fill="none"
        stroke="#000"
        strokeWidth="0.4"
        opacity="1"
      ></circle>
      <path
        id="rect70"
        fill="#000"
        stroke="none"
        strokeWidth="0.545"
        d="M3.175.53v5.29a2.638 2.646 0 0 0 2.638-2.645A2.638 2.646 0 0 0 3.175.529"
        display="inline"
        opacity="1"
      ></path>
      <circle
        id="path69"
        cx="3.175"
        cy="3.175"
        r="1.149"
        fill="none"
        stroke="#000"
        strokeWidth="0.347"
        opacity="1"
      ></circle>
      <circle
        id="path70"
        cx="3.175"
        cy="3.175"
        r="0.44"
        fill="#fff"
        stroke="#fff"
        strokeWidth="1.081"
        opacity="1"
      ></circle>
    </g>
  </svg>
);

export default WhiteMode;
